export default "__VITE_ASSET__CUw9WlNx__"